<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t("add") }} {{ $tc("city", 2) }}</div>
      <router-link class="btn-blue" to="cities"
        >{{ $tc("city", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row">
        <!-- CINEMAS SELECTION -->
        <div
          v-for="(item, index) in Cities"
          :key="index"
          v-if="item.fieldname !== 'city_id'"
          class="col-lg-6 col-xl-4 align-self-center mb-4"
        >
          <div v-if="item.type !== 'radio' && item.type !== 'dropdown'">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  @focus="onFocusHandler"
                  :type="item.type"
                  :name="item.fieldname"
                  :id="item.fieldname"
                  v-validate="item.validation"
                  v-model="item.fieldvalue"
                  placeholder="."
                  v-b-tooltip.hover.top="$t(item.tooltip)"
                />
                <label>{{ $tc(item.label, 1) }}</label>
              </div>
              <!-- <Tooltip :title="$t(item.tooltip)" /> -->
            </div>
            <p class="error_message">
              <!-- {{ item.fieldname }} -->
              <span v-if="submitted && errors.has(item.fieldname)">{{
                errors.first(`${item.fieldname}`)
              }}</span>
            </p>
          </div>

          <div v-if="item.type === 'radio'">
            <div class="d-flex align-items-center min-height-50">
              <label class="mb-0 mr-3">{{ $t("active") }}</label>
              <!-- <label class="ios-switch"> -->
              <b-form-checkbox
                type="checkbox"
                class="j-checkbox"
                v-model="item.fieldvalue"
              />
              <!-- <span class="switch-slider"></span>
              </label> -->
            </div>
            <p class="error_message">
              <!-- {{ item.fieldname }} -->
              <span></span>
            </p>
          </div>

          <div v-if="item.type === 'dropdown'">
            <div v-if="item.fieldname === 'country_id'">
              <div class="d-flex align-items-center">
                <div class="dropdown-curve-container">
                  <label
                    :class="item.dropdownSelected.length > 0 ? 'shift-up' : ''"
                    >{{ $tc(item.label, 1) }}</label
                  >
                  <b-dropdown
                    :text="item.dropdownSelected"
                    variant="dropdown-curve"
                    class="w-100"
                    v-b-tooltip.hover.top="$t(item.tooltip)"
                  >
                    <div class="px-2 pb-2">
                      <input
                        required
                        autofocus
                        type="search"
                        placeholder="Search country"
                        class="form-control form-control-sm"
                        v-on:keyup="onSearchCountry()"
                        v-on:keydown="onSearchCountry()"
                        v-on:search="onSearchCountry()"
                        v-model="searchCountry"
                      />
                    </div>
                    <b-dropdown-item
                      v-for="(dropdownItem, dropdownIndex) in countryList"
                      :key="dropdownIndex"
                      href="#"
                      @click="
                        onDropdownChange(
                          $event,
                          item.label,
                          dropdownItem,
                          index
                        )
                      "
                      >{{ dropdownItem.country_name }}</b-dropdown-item
                    >
                  </b-dropdown>
                </div>

                <!-- <Tooltip :title="$t(item.tooltip)" /> -->
              </div>
              <p class="error_msg">
                <span v-if="submitted && item.dropdownSelected.length == 0">{{
                  msgcountry
                }}</span>
              </p>
            </div>

            <div v-if="item.fieldname === 'state_id'">
              <div v-if="stateactive" class="d-flex align-items-center">
                <div class="d-flex mt-2 pr-2"></div>

                <div class="dropdown-curve-container">
                  <label
                    :class="item.dropdownSelected.length > 0 ? 'shift-up' : ''"
                    >{{ $tc(item.label, 1) }}</label
                  >
                  <b-dropdown
                    :text="item.dropdownSelected"
                    variant="dropdown-curve"
                    class="w-100"
                    v-b-tooltip.hover.top="$t(item.tooltip)"
                  >
                    <div class="px-2 pb-2">
                      <input
                        required
                        autofocus
                        type="search"
                        placeholder="Search state"
                        class="form-control form-control-sm"
                        v-on:keyup="onSearchState()"
                        v-on:keydown="onSearchState()"
                        v-model="searchState"
                      />
                    </div>
                    <b-dropdown-item
                      v-for="(dropdownItem, dropdownIndex) in stateList"
                      :key="dropdownIndex"
                      href="#"
                      @click="
                        onDropdownChange(
                          $event,
                          item.label,
                          dropdownItem,
                          index
                        )
                      "
                      >{{ dropdownItem.state_name }}</b-dropdown-item
                    >
                  </b-dropdown>
                </div>

                <!-- <Tooltip :title="$t(item.tooltip)" /> -->
              </div>
              <p v-if="stateactive" class="error_msg">
                <span v-if="submitted && item.dropdownSelected.length == 0">{{
                  msgstate
                }}</span>
              </p>
            </div>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            class="btn-blue"
            @click.prevent.stop="onFinalSubmit(true)"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(false)"
            type="submit"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="onResetForm()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button class="btn-outline-grey" variant="default" to="cities">{{
            $t("cancel")
          }}</b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Cities from "@/helper/formJSONMaster/Cities";

export default {
  data() {
    return {
      btenable: false,
      msgcountry: "Please Select Country.",
      msgstate: "Please Select State.",
      msglatitude: "",
      msglongitude: "",
      Cities: Cities.ms_cities,
      submitted: false,
      Methods: Cities.Methods,
      countryList: [],
      countryListCopy: [],
      searchCountry: "",
      stateList: [],
      stateListCopy: [],
      searchState: "",
      stateactive: false,
    };
  },
  beforeMount() {
    this.getCountryList();
    this.onResetForm();
  },
  mounted() {},
  methods: {
    onFocusHandler: function () {
      // this.submitted = false;
    },
    onSearchState: function () {
      if (this.searchState && this.searchState.length > 0) {
        this.stateList = this.stateListCopy.filter((x) => {
          if (
            x.state_name.toLowerCase().includes(this.searchState.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.stateList = this.stateListCopy;
      }
    },
    getStateList: function (id) {
      this.stateList = [];
      let body = this.getRequestBody("GET", undefined, {
        GET: "/admin/tablelist/",
        tableName: "ms_states",
        params: { id: "country_id-" + id },
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          console.log("data :", data);
          if (data.status && data.Records.length > 0) {
            this.stateList = data.Records;
            this.stateListCopy = data.Records;
            this.Cities.map((x) => {
              if (x.fieldname === "state_id") {
                x.dropdownSelected = "";
                x.fieldvalue = "";
              }
            });
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    onSearchCountry: function () {
      if (this.searchCountry && this.searchCountry.length > 0) {
        this.countryList = this.countryListCopy.filter((x) => {
          if (
            x.country_name
              .toLowerCase()
              .includes(this.searchCountry.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.countryList = this.countryListCopy;
      }
    },
    getCountryList: function () {
      let body = this.getRequestBody("GET", undefined, {
        GET: "/admin/",
        tableName: "ms_countries",
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.countryList = data.Records;
            this.countryListCopy = data.Records;
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch((error) => {
          console.log("show error2 :", error);
        });
    },
    onDropdownChange: function (event, type, item, mainIndex) {
      // this.States[mainIndex].fieldvalue = item.country_name;
      // console.log("item :", item);

      if (type === "country") {
        this.Cities[mainIndex].fieldvalue = item.country_id;
        this.Cities[mainIndex].dropdownSelected = item.country_name;
        this.stateactive = true;
        // console.log(
        //   "this.Cities[mainIndex].dropdownSelected :",
        //   this.Cities[mainIndex].dropdownSelected
        // );
        this.getStateList(item.country_id);
      } else if (type === "state") {
        this.Cities[mainIndex].dropdownSelected = item.state_name;
        this.Cities[mainIndex].fieldvalue = item.state_id;
      }
    },
    onResetForm: function () {
      this.Cities.map((x) => {
        if (x.type === "text" || x.type === "date" || x.type === "number") {
          x.fieldvalue = "";
        } else if (x.type === "dropdown") {
          x.fieldvalue = "";
          x.dropdownSelected = "";
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        }
      });
      this.stateactive = false;
    },
    onFinalSubmit: function (redirect) {
      // if(!this.Cities[2].fieldvalue.includes(".")){
      //   alert("fsdf");
      //   return false;
      // }
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          if (this.Cities[5].fieldvalue == "") {
            return;
          } else if (this.Cities[6].fieldvalue == "") {
            return;
          } else {
            this.btenable = true;
            let body = this.getRequestBody("POST", this.Cities, this.Methods);

            MasterService.GlobalRequest(body)
              .then((response) => {
                this.btenable = false;
                const { data } = response;
                if (data.status) {
                  this.onResetForm();
                  if (redirect) {
                    this.$router.push({
                      path: "/master/cities",
                    });
                  }
                } else {
                  // Show Error Message:
                  this.$toasted.show(data.message);
                  console.log("data.message :", data.message);
                }
              })
              .catch((error) => {
                // Catch Error:
                console.log("Catch Error On onFinalSubmit :", error);
              });
          }
          // }
        } else {
          this.submitted = true;

          console.log("else :");
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/CityComponents/addCity.vue